<template>
    <div id="produk-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Kode Voucher',
                    to: { path: '/kode-voucher' },
                    exact: true,
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Kode Voucher'
                        : 'Ubah Kode Voucher',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Kode Voucher" : "Ubah Kode Voucher" }}
        </h3>

        <v-card plain class="pa-7">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-600 pb-2"
                        style="font-size: 14px"
                    >
                        Nama Voucher *
                    </v-list-item-title>
                    <v-text-field
                        class="pb-2"
                        placeholder="Nama Paket"
                        v-model="data.package_name"
                        maxLength="50"
                        persistent-hint
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item class="pa-0">
                <v-row>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-600 pb-2"
                                    style="font-size: 14px"
                                >
                                    Waktu Mulai *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-menu
                                                ref="menu"
                                                :close-on-content-click="true"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        :disabled="queryId"
                                                        v-model="
                                                            data.start_date
                                                        "
                                                        append-icon="mdi-calendar"
                                                        placeholder="Tanggal"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    :disabled="queryId"
                                                    v-model="data.start_date"
                                                    :min="
                                                        new Date()
                                                            .toISOString()
                                                            .slice(0, 10)
                                                    "
                                                    no-title
                                                    scrollable
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-600 pb-2"
                                    style="font-size: 14px"
                                >
                                    Waktu Berakhir *
                                </v-list-item-title>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-menu
                                                ref="menu"
                                                :close-on-content-click="true"
                                                transition="slide-y-reverse-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-text-field
                                                        v-model="
                                                            data.expiry_date
                                                        "
                                                        :disabled="queryId"
                                                        append-icon="mdi-calendar"
                                                        placeholder="Tanggal"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="data.expiry_date"
                                                    :disabled="queryId"
                                                    :min="
                                                        new Date()
                                                            .toISOString()
                                                            .slice(0, 10)
                                                    "
                                                    no-title
                                                    scrollable
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-600 pb-2"
                        style="font-size: 14px"
                    >
                        Pilihan Paket Belajar *
                    </v-list-item-title>

                    <v-select
                        outlined
                        placeholder="Pilihan Paket Belajar"
                        :disabled="!!queryId"
                        v-model="data.package_category"
                        @change=""
                        class="pa-0"
                        :items="[
                            { text: 'PACKAGES', value: 'PACKAGES' },
                            { text: 'ADDON', value: 'ADDON' },
                        ]"
                    ></v-select>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-600 pb-2"
                        style="font-size: 14px"
                    >
                        Jumlah Voucher *
                    </v-list-item-title>
                    <v-text-field
                        type="number"
                        class="pb-2"
                        placeholder="Nama Paket"
                        v-model="data.package_name"
                        maxLength="5"
                        persistent-hint
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-600 pb-2"
                        style="font-size: 14px"
                    >
                        Batas Penggunaan per User *
                    </v-list-item-title>
                    <v-text-field
                        type="number"
                        class="pb-2"
                        placeholder="Nama Paket"
                        v-model="data.package_name"
                        maxLength="5"
                        persistent-hint
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-600 pb-2"
                        style="font-size: 14px"
                    >
                        Kode Voucher *
                    </v-list-item-title>
                    <v-text-field
                        class="pb-2"
                        placeholder="Nama Paket"
                        v-model="data.package_name"
                        maxLength="5"
                        persistent-hint
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item class="pa-0 mb-5">
                <v-list-item-title>
                    <span class="font-weight-700" style="font-size: 18px"
                        >Pengaturan Diskon</span
                    >
                </v-list-item-title>
            </v-list-item>

            <v-list-item
                two-line
                class="pa-0"
                v-if="data.package_category !== 'ADDON'"
            >
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500"
                        style="font-size: 14px"
                    >
                        Tipe Diskon *
                    </v-list-item-title>

                    <v-radio-group
                        row
                        v-model="data.package_level"
                        @change="data.package_grade = []"
                        mandatory
                    >
                        <v-radio
                            label="% Persen Diskon"
                            value="1"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            label="Nominal Diskon"
                            value="2"
                            class="jenjang-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-600 pb-2"
                        style="font-size: 14px"
                    >
                        Persen Diskon
                    </v-list-item-title>
                    <v-text-field
                        type="number"
                        placeholder="Dalam Bentuk Persen (%)"
                        v-model="data.consul_session"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-card-actions class="py-2 mt-5">
                <v-spacer></v-spacer>

                <v-btn text @click="$router.push({ path: '/kode-voucher' })">
                    Batal
                </v-btn>

                <v-btn
                    color="primary"
                    depressed
                    @click="!$route.query.id ? saveData() : editData()"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Jadwalkelaschooser from "@/modules/pembayaran/components/JadwalKelasChooser";
import Moment from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "voucher-code-form",

    components: {
        "app-jadwalkelaschooser": Jadwalkelaschooser,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            type: {
                SUBSCRIPTION: "SUBSCRIPTION",
                TICKET: "TICKET",
            },
            queryId: null,
            selectedPicture: null,
            data: {
                package_level: "",
                type: "SUBSCRIPTION",
                discount: null,
                package_name: null,
                package_type: "",
                app_scope: [""],
                user_group_id: null,
                package_description: null,
                package_category: "",
                package_grade: null,
                package_groups: [],
                code: "",
                consul_session: "",
                normal_price: 0,
                start_date: "",
                expiry_date: "",
                actual_price: 0,
                is_active: 1,
                is_show: 0,
                is_ios: 0,
            },
            userGroups: [],
            tryouts: [],
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "blockQuote",
                    "|",
                    "outdent",
                    "indent",
                ],
            },
            app_scope: [],
            scopes: [
                {
                    id: 8,
                    text: "app_scheduled_tryout",
                    display_text: "User: Access Scheduled Tryout",
                    description:
                        "Give user privilege to access scheduled tryout feature",
                    created_at: "2019-03-13 00:47:03",
                    updated_at: "2019-03-13 00:47:03",
                },
                {
                    id: 9,
                    text: "app_itembank",
                    display_text: "User: Access Itembank",
                    description:
                        "Give user privilege to access itembank feature",
                    created_at: "2019-03-13 00:47:03",
                    updated_at: "2019-03-13 00:47:03",
                },
                {
                    id: 55,
                    text: "app_consultation",
                    display_text: "app_consultation",
                    display_name: "User: Access Consultation",
                    description:
                        "Give privileges to access consultation features",
                    created_at: "2020-05-04 02:44:01",
                    updated_at: "2020-05-04 02:44:01",
                },
                {
                    id: 64,
                    text: "app_liveclass",
                    display_text: "app_liveclass",
                    display_name: "User: Access Live Class",
                    description:
                        "Give privileges to access live class features",
                    created_at: "2021-07-18 12:20:45",
                    updated_at: "2021-07-18 12:32:06",
                },
            ],
            topic: null,
            startDate: null,
            endDate: null,
            liveclass_schedulled: false,
        };
    },

    watch: {
        "data.app_scope": function (val) {
            var check_app_scope = val.includes(64);
            if (check_app_scope) {
                this.liveclass_schedulled = true;
            } else {
                this.liveclass_schedulled = false;
            }
        },
    },

    mounted: function () {
        var context = this;
        if (this.$route.query.id) {
            this.queryId = this.$route.query.id;
            // this.fetchData();
        }
        if (!this.$route.query.id) {
            DatepickerPlugin.init("#startDate", function (value) {
                context.data.start_date = value;
            });

            DatepickerPlugin.init("#endDate", function (value) {
                context.data.expiry_date = value;
            });
        }
        this.getUserGroup();
        this.getAppScope();
    },

    methods: {
        fetchData: function () {
            var context = this;
            var queryId = this.queryId;
            var jadwalkelases = [];
            this.isLoading = true;

            SalesService.getDetailPaket(queryId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    context.data.package_name = result.data.name;
                    context.data.package_type = result.data.type;
                    context.data.discount = result.data.discount;
                    context.data.app_scope = result.data.package_app_scope;
                    context.data.package_description = result.data.description;
                    context.data.feature_description =
                        result.data.feature_package;
                    context.data.package_category =
                        result.data.package_category;
                    context.data.user_group_id = result.data.user_group_id;
                    context.data.addon_value = result.data.addon_value;
                    if (context.data.package_category === "PACKAGES") {
                    }
                    context.data.package_grade = result.data.grade_package[0];
                    context.data.package_level = result.data.level;
                    context.data.normal_price = result.data.normal_price;
                    context.data.actual_price = result.data.actual_price;
                    context.data.consul_session = result.data.consul_session;
                    context.data.is_show = result.data.is_show;
                    context.data.is_ios = result.data.is_ios;
                    if (result.data.start_date) {
                        context.data.start_date = Moment(
                            result.data.start_date,
                        ).format("YYYY-MM-DD");
                        context.data.expiry_date = Moment(
                            result.data.expiry_date,
                        ).format("YYYY-MM-DD");
                    }
                    result.data.package_group.forEach((element) => {
                        const datas = {
                            id: element.id,
                            desc: element.description,
                            quota: element.quota,
                            threshold: element.threshold,
                            start_time: Moment(element.start_time).format(
                                "HH:mm",
                            ),
                            end_time: Moment(element.end_time).format("HH:mm"),
                        };
                        context.data.package_groups.push(element.id);
                        jadwalkelases.push(datas);
                    });

                    context.tryouts = jadwalkelases;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        submessage: result.message,
                        type: "error",
                    });
                }
            });
        },

        saveData: function () {
            var context = this;
            var data = this.data;

            if (this.validateForm()) {
                context.isLoading = true;
                if (context.data.package_category === "PACKAGES") {
                    data.package_grade = [data.package_grade];
                } else {
                    data.package_grade = [];
                    data.package_level = "ALL";
                }

                data.start_date = Moment(data.start_date, "YYYY-MM-DD").format(
                    "DD/MM/YYYY",
                );
                data.expiry_date = Moment(
                    data.expiry_date,
                    "YYYY-MM-DD",
                ).format("DD/MM/YYYY");

                SalesService.createPaket(data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        editData: function () {
            var context = this;
            var id = this.queryId;
            var data = this.data;
            this.isLoading = true;
            if (this.validateForm()) {
                if (context.data.package_category === "PACKAGES") {
                    data.package_grade = [this.data.package_grade];
                } else {
                    data.package_grade = [];
                    data.package_level = "ALL";
                }

                data.start_date = Moment(data.start_date, "YYYY-MM-DD").format(
                    "DD/MM/YYYY",
                );
                data.expiry_date = Moment(
                    data.expiry_date,
                    "YYYY-MM-DD",
                ).format("DD/MM/YYYY");

                SalesService.updatePaket(id, data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        validateForm() {
            var err = false;
            var context = this;
            if (!this.data.package_category) {
                this.$store.commit("showAlert", {
                    message: `Tipe produk wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else {
                if (!this.data.package_name) {
                    this.$store.commit("showAlert", {
                        message: `Nama Paket wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.package_level) {
                    this.$store.commit("showAlert", {
                        message: `Jenjang wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.package_description) {
                    this.$store.commit("showAlert", {
                        message: `Deskripsi wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (this.data.package_category === "PACKAGES") {
                    if (this.data.package_grade.length < 1) {
                        this.$store.commit("showAlert", {
                            message: `Kelas wajib diisi!`,
                            type: "error",
                        });
                        err = true;
                    }
                }

                if (!this.data.feature_description) {
                    this.$store.commit("showAlert", {
                        message: `Fitur wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.actual_price) {
                    this.$store.commit("showAlert", {
                        message: `Harga Asli wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!!this.data.normal_price) {
                    if (
                        Number(this.data.actual_price) >=
                        Number(this.data.normal_price)
                    ) {
                        this.$store.commit("showAlert", {
                            message: `Harga Asli tidak boleh lebih dari atau sama dengan Harga Normal!`,
                            type: "error",
                        });
                        err = true;
                    }
                }

                if (this.data.package_category === "PACKAGES") {
                    if (this.data.package_grade.length < 1) {
                        this.$store.commit("showAlert", {
                            message: `Kelas wajib diisi!`,
                            type: "error",
                        });
                        err = true;
                    }

                    if (!this.data.package_level) {
                        this.$store.commit("showAlert", {
                            message: `Jenjang wajib diisi!`,
                            type: "error",
                        });
                        err = true;
                    }

                    if (this.data.app_scope.length > 0) {
                        this.data.app_scope.forEach((e) => {
                            if (e == "") {
                                context.$store.commit("showAlert", {
                                    message: `User scope wajib diisi!`,
                                    type: "error",
                                });
                                err = true;
                            }
                        });
                    }

                    var check_app_scope = this.data.app_scope.includes(64);
                    if (check_app_scope) {
                        if (this.data.package_groups.length < 1) {
                            this.$store.commit("showAlert", {
                                message: `Jadwal Kelas wajib diisi!`,
                                type: "error",
                            });
                            err = true;
                        }
                    }
                } else {
                    this.data.app_scope = [];
                    this.data.package_groups = [];
                }

                if (
                    this.data.package_type === "ANNUALLY" &&
                    !this.data.start_date
                ) {
                    this.$store.commit("showAlert", {
                        message: `Tanggal mulai wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (
                    this.data.package_type === "ANNUALLY" &&
                    !this.data.expiry_date
                ) {
                    this.$store.commit("showAlert", {
                        message: `Tanggal selesai wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                    this.errors.push("Tanggal selesai wajib di isi");
                }
            }
            return !err;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// VoucherCodeForm.vue?a0660894